import DocIcon from "assets/icons/file-icons/DocFile";
import {ReactNode} from "react";
import PdfFileIcon from "assets/icons/file-icons/PdfFile";
import TxtFileIcon from "assets/icons/file-icons/TxtFile";
import Mp4FileIcon from "assets/icons/file-icons/Mp4File";
import PptFileIcon from "assets/icons/file-icons/PptFile";
import PngFileIcon from "assets/icons/file-icons/PngFile";
import SvgFileIcon from "assets/icons/file-icons/SvgFile";
import XlsFileIcon from "assets/icons/file-icons/XlsFile";
import ZipFileIcon from "assets/icons/file-icons/ZipFile";
import {Box} from "@mui/material";
import OtherFileIcon from "assets/icons/file-icons/OtherFile";

type IconMap = {
  [extension: string]: ReactNode;
};

const iconMap: IconMap = {
  pdf: <PdfFileIcon/>,
  txt: <TxtFileIcon/>,
  mp4: <Mp4FileIcon/>,
  doc: <DocIcon />,
  ppt: <PptFileIcon/>,
  png: <PngFileIcon/>,
  svg: <SvgFileIcon/>,
  xls: <XlsFileIcon/>,
  zip: <ZipFileIcon/>,
};

type FileIconProps = {
  fileName: string;
};

const FileIcon = ({ fileName }: FileIconProps) => {
  const extension = fileName.split(".").pop()?.toLowerCase();
  const icon = extension && iconMap[extension] ? iconMap[extension] : null;

  return (
    <Box sx={{
      mb: {xxs: 2, md: 0},
      mr: {md: 2},
      '& svg': {
        width: 40,
        height: 48
      }
    }}>
      {icon ? icon : <OtherFileIcon extension={extension}/>}
    </Box>
  );
};


export default FileIcon;
